import React from 'react';

interface IconProps {
  className?: string;
  size?: number;
  iconName: string;  // Nombre del icono específico, como "home", "user", etc.
  iconColor: 'orange' | 'white' | 'black';
  backgroundColor?: 'orange' | 'white' | 'black';  // El fondo es opcional
}

export const Icon: React.FC<IconProps> = ({ className, size = 24, iconName, iconColor, backgroundColor }) => {
  let imagePath = `${process.env.PUBLIC_URL}/icons/${iconColor}`;
  
  if (backgroundColor) {
    imagePath += `/${backgroundColor}_background`;
  } else {
    imagePath += `/no_background`;
  }
  
  imagePath += `/${iconName}.png`;

  return (
    <div className={`icon-container ${className}`} style={{ width: size, height: size }}>
      <img 
        src={imagePath}
        alt={`${iconColor} icon with ${backgroundColor || 'no'} background`}
        style={{ width: '100%', height: '100%' }}
      />
    </div>
  );
};
